const revolveAroundRandomly = function(args) {
    return args;
}
export default revolveAroundRandomly;